import { render, staticRenderFns } from "./Evasione.vue?vue&type=template&id=97458a1e&"
import script from "./Evasione.vue?vue&type=script&lang=js&"
export * from "./Evasione.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports